import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { YoutubeVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/youtube-video-preview-data.interface';
import { UrlDisplayHelper } from '../../../../../../../utils/url-display-helper';
import { YoutubeFormatHelper } from '../../../../../../../utils/youtube-format-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

/**
 * Skippable in-stream ad on a Google video partner site, desktop, for the
 * YouTube Video Ad template. The partner page lays the player and its article
 * column side by side, and the copy rides on the creative as a companion card.
 * The template takes a single video of any format, so the creative is drawn
 * contained on the player's dark ground and a 1:1 or 9:16 video is pillarboxed.
 */
@Component({
    selector: 'app-youtube-video-partners-in-stream-desktop',
    imports: [CommonModule, DesktopFrameComponent],
    templateUrl: './video-partners-in-stream-desktop.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './video-partners-in-stream-desktop.component.scss'
})
export class YoutubeVideoPartnersInStreamDesktopPreviewComponent {
  @Input() data!: YoutubeVideoPreviewData;

  /** Skeleton text lines in the article column; the last one is short. */
  readonly railLines = [0, 1, 2, 3, 4, 5, 6, 7, 8];

  /** Thumbnail of the video, or '' when there isn't one yet. */
  get thumbnailUrl(): string {
    return YoutubeFormatHelper.thumbnailFor(this.videoId);
  }

  /** True while the link is still being measured, so the empty player says so. */
  get isResolving(): boolean {
    return YoutubeFormatHelper.isResolving(this.videoId);
  }

  /** The host, which is all the card shows of the destination. */
  get displayUrl(): string {
    return UrlDisplayHelper.hostOf(this.data.url);
  }

  get headline(): string {
    return this.data.headline || 'Your headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Your call to action';
  }

  private get videoId(): string {
    return this.data.video?.videoId ?? '';
  }
}
